import { PHASES, type MeetingPhase } from "../constants";

type Props = {
  phase: MeetingPhase;
  onChange: (phase: MeetingPhase) => void;
};

export function PhaseNav({ phase, onChange }: Props) {
  return (
    <nav className="tm-phase-nav" role="tablist">
      {PHASES.map((p) => (
        <button
          key={p.key}
          type="button"
          role="tab"
          aria-selected={phase === p.key}
          className={`tm-phase-nav__tab${phase === p.key ? " tm-phase-nav__tab--active" : ""}`}
          onClick={() => onChange(p.key)}
        >
          {p.label}
        </button>
      ))}
    </nav>
  );
}
